// Treeshaking safe.
const VideoQuality = function VideoQuality() {};
VideoQuality.UNKNOWN = 0;
VideoQuality.XXS = 144;
VideoQuality.XS = 240;
VideoQuality.S = 360;
VideoQuality.M = 480;
VideoQuality.L = 720;
VideoQuality.XL = 1080;
VideoQuality.XXL = 1440;
VideoQuality.MAX = 2160;
export default VideoQuality;
